import {
  Box,
  Divider,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { GetLayout } from "components/get-layout";
import { RoutePermissionFunction } from "router-manager/parts/types";
import { useMemo, useState } from "react";
import {
  SERVICES,
  getTotalEndpoints,
  serviceMatchesFilter,
  ServiceCard,
  MetricCard
} from "components/docs-api-gateway-components";

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function DocsApiGatewayPage() {
  const [filter, setFilter] = useState("");

  const filteredServices = useMemo(
    () => SERVICES.filter((s) => serviceMatchesFilter(s, filter)),
    [filter]
  );

  const totalEndpoints = getTotalEndpoints(SERVICES);

  return (
    <GetLayout>
      <Box w="100%">
        {/* ── Header ── */}
        <Flex align="flex-start" justify="space-between" gap="20px" mb="24px">
          <Box>
            <Text
              fontSize="26px"
              fontWeight="700"
              color="#1E293B"
              lineHeight="1.2"
              mb="8px"
            >
              Documentação API Gateway
            </Text>
            <Text fontSize="14px" color="gray.500" maxW="520px">
              Bem-vindo ao portal do desenvolvedor. Aqui você encontra
              documentação completa para todos os nossos serviços.
            </Text>
          </Box>
          <Flex gap="10px" flexShrink={0} mt="4px">
            <MetricCard value={SERVICES.length} label="Services" />
            <MetricCard value={totalEndpoints} label="Endpoints" />
          </Flex>
        </Flex>

        <Divider borderColor="gray.200" mb="28px" />

        {/* ── Explore Services ── */}
        <Text fontSize="16px" fontWeight="700" color="#1E293B" mb="14px">
          Explorar Serviços
        </Text>

        {/* ── Search ── */}
        {/* <InputGroup mb="20px" maxW="400px">
          <InputLeftElement pointerEvents="none">
            <SearchIcon color="gray.400" boxSize="14px" />
          </InputLeftElement>
          <Input
            placeholder="Filtrar por caminho ou descrição..."
            fontSize="13px"
            bg="white"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="10px"
            _placeholder={{ color: "gray.400" }}
            _focus={{ borderColor: "blue.400", boxShadow: "none" }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </InputGroup> */}

        {/* ── Service List ── */}
        <Flex direction="column" gap="14px">
          {filteredServices.length === 0 ? (
            <Box py="40px" textAlign="center" color="gray.400" fontSize="14px">
              Nenhum serviço encontrado para &quot;{filter}&quot;.
            </Box>
          ) : (
            filteredServices.map((service) => (
              <ServiceCard key={service.name} service={service} />
            ))
          )}
        </Flex>
      </Box>
    </GetLayout>
  );
}

// ─── Route Permissions ────────────────────────────────────────────────────────

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission(
    (user) => !!user?.userData.authorities?.includes("API")
  );
};
